// extracted by mini-css-extract-plugin
module.exports = {"component":"quote_component__3vp9x","title":"quote_title__2SpCl","quote":"quote_quote__2yAQS","hasAnimation":"quote_hasAnimation__1GY5u","author":"quote_author__3vGHb"};